import * as React from 'react';
import GenericHoc from 'components/common/generic-hoc';
import { HocOptions } from 'components/common/generic-hoc.types';
import { StylesProps, ThemeType } from 'theme/jss-types';
import { formFields } from 'components/create-consignment/create-modal.constants';
import { useTranslation } from 'react-i18next';
import {
    Col,
    Form,
    FormInstance,
    Input,
} from 'antd';
import { commonStyleSheet } from 'library/common-styles';

const styles = (theme: ThemeType) => ({
    formItem: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'left',
        '& .ant-checkbox + span': {
            color: '#111111',
            fontSize: 14,
            fontWeight: 600,
        },
    },
    title: {
        color: '#333333',
        fontFamily: 'Open Sans',
        fontSize: 12,
        letterSpacing: 0,
        width: '100%',
        marginBottom: 4,
        marginLeft: 4,
    },
    referenceTitle: {
        color: '#333333',
        fontFamily: 'Open Sans',
        fontSize: 12,
        letterSpacing: 0,
        width: '100%',
        marginBottom: 4,
    },
    contentType: {
        ...commonStyleSheet(theme).flexRow,
        '& .ant-form-item': {
            marginBottom: 0,
        },
    },
});

interface IProps extends StylesProps<ReturnType<typeof styles>> {
    params: any;
    form: FormInstance;
    shouldNotMakeItemTypeCheck: boolean;
    invoiceTypeField?: boolean;
}

const PieceReferenceNumberField = (props: IProps) => {
    const { t } = useTranslation();
    const {
        classes,
        params,
        form,
        shouldNotMakeItemTypeCheck,
        invoiceTypeField = false,
    } = props;
    const {
        ReferenceNumber,
        ItemType,
    } = formFields;
    const {
        key,
        isRequired,
        getValidationRules,
        getIsRequiredValidation,
        editData,
    } = params;

    const itemType = Form.useWatch(ItemType.key, form);

    if (!shouldNotMakeItemTypeCheck && itemType !== 'non-document') {
        return <></>;
    }

    // Disabled in edit mode; the backend value is prepopulated via form.setFieldsValue by the parent.
    const shouldFieldBeDisabled = !!editData;

    return (
        <Col span={24} xs={24} sm={24} md={12}>
            <div className={classes.formItem}>
                <div
                    className={classes.title}
                >
                    {t('piece_reference_number')}
                    {!invoiceTypeField && (isRequired(true, ReferenceNumber.key)
                        || getIsRequiredValidation(ReferenceNumber.key, true) ? '*' : '')}
                </div>
                <Form.Item
                    name={key}
                    className={classes.contentType}
                    valuePropName={ReferenceNumber.valuePropName}
                    rules={getValidationRules(ReferenceNumber, true)}
                >
                    <Input
                        disabled={shouldFieldBeDisabled}
                        placeholder={t('piece_reference_number')}
                    />
                </Form.Item>
            </div>
        </Col>
    );
};

const hocConfig: HocOptions = {
    connectRedux: {
        useRedux: true,
    },
    connectJss: {
        useJss: true,
        styleSheet: styles,
    },
};

export default GenericHoc(hocConfig)(PieceReferenceNumberField);
